import React, { useEffect, useState, useRef } from "react";
import { Spin, Table, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import moment from "moment";
import backend from "../../../api/api";
import Excelldownload from "./Excelldownload";

const { Title, Paragraph } = Typography;
const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

const AbsentReport = ({ startDate, endDate, location }) => {
  const [loading, setLoading] = useState(true);
  const [absentData, setAbsentData] = useState([]);
  const componentRef = useRef();

  useEffect(() => {
    const fetchAbsentData = async () => {
      setLoading(true);
      try {
        const params = {
          start_date: moment(startDate).format("YYYY-MM-DD"),
          end_date: moment(endDate).format("YYYY-MM-DD"),
          areas: "1,2,3,4",
          page: 1,
          page_size: 10000,
        };

        const res = await backend.get("/api/hrm/absent-report-new/", {
          params,
        });

        setAbsentData(res.data.data || []);
      } catch (error) {
        console.error("Error fetching absent report:", error);
        setAbsentData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAbsentData();
  }, [startDate, endDate, location]);

  const columns = [
    {
      title: "SL",
      key: "index",
      render: (text, record, index) => index + 1,
    },
    {
      title: "PIN",
      dataIndex: "emp_code",
      key: "emp_code",
    },
    {
      title: "Name",
      dataIndex: "first_name",
      key: "first_name",
    },
    {
      title: "Department",
      dataIndex: "dept_name",
      key: "dept_name",
    },
    {
      title: "Designation",
      dataIndex: "position_name",
      key: "position_name",
    },
    {
      title: "Last Attendended",
      dataIndex: "last_punch",
      key: "last_punch",
    },
  ];

  const transformedData = absentData.map((item) => ({
    EPIN: item.emp_code,
    employee: item.first_name,
    department: item.dept_name,
    designation: item.position_name,
  }));

  return (
    <div ref={componentRef}>
      <div style={{ marginBottom: "16px" }}>
        <Title level={3} style={{ marginBottom: 0 }}>
          Famous Design LTD.
        </Title>
        <Paragraph style={{ margin: 0 }}>
          245/1-F, West Agargoan, Sher-E-Bangla Nagar, Dhaka-1207.
        </Paragraph>
        <Paragraph strong underline style={{ margin: "5px 0" }}>
          Absent Report
        </Paragraph>
        <Paragraph>Date: {moment(startDate).format("DD-MM-YYYY")}</Paragraph>
      </div>

      <div style={{ marginBottom: "16px" }}>
        <Excelldownload
          data={{ attendanceData: transformedData }}
          startDate={startDate}
          endDate={endDate}
        />
      </div>

      {loading ? (
        <div
          style={{
            padding: "60px 0",
            textAlign: "center",
          }}
        >
          <Spin indicator={antIcon} tip="Loading Absent Report..." />
        </div>
      ) : (
        <Table
          columns={columns}
          dataSource={absentData}
          rowKey="emp_code"
          pagination={{ pageSize: 100 }}
          bordered
        />
      )}
    </div>
  );
};

export default AbsentReport;
